angular.module('autoremind.reports.config', [])
    .constant('reportConfig', (function () {
    var reportTypes = [{
            name: 'contacts',
            position: 4,
            permissions: [{ "key": "autoremind3" }],
            icon: 'reports-contacts.jpg',
            desc: '_patientContactStatisticsReport_',
            isVisible: true
        }, {
            name: 'todo',
            position: 2,
            permissions: [{ "key": "autoremind3" }],
            icon: 'reports-todo.jpg',
            desc: '_todoReport_',
            isVisible: true
        }, {
            name: 'unsubscribe',
            position: 3,
            permissions: [{ "key": "autoremind3" }],
            icon: 'reports-unsubscribe.jpg',
            desc: '_unsubscribeReport_',
            isVisible: true
        }, {
            name: 'messaging',
            position: 1,
            permissions: [{ "key": "autoremind2" }, { "bool": "OR" }, { "key": "autoremind3" }, { "bool": "OR" }, { "key": "communication" }],
            icon: 'reports-messaging.jpg',
            desc: '_messaging_Report_',
            isVisible: true
        }, {
            name: 'messaging',
            param: 'birthday',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-birthday.jpg',
            desc: '_birthday_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'newsletter',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-newsletter.jpg',
            desc: '_newsletter_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'seasonal',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-seasonal.jpg',
            desc: '_seasonal_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'recalls',
            position: 6,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-recalls.jpg',
            desc: '_communicationsRecallsReport_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'sale',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-sale.jpg',
            desc: '_sale_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'missed',
            position: 7,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-missed.jpg',
            desc: '_communicationsMissedReport_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'shortnotice',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-shortnotice.jpg',
            desc: '_shortnotice_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'survey',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-survey.jpg',
            desc: '_communicationsSurveyReport_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'reviews',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-reviews.jpg',
            desc: '_reviews_Report_',
            isVisible: true,
            isCommunication: true
        }, {
            name: 'messaging',
            param: 'latepayment',
            position: 1,
            permissions: [{ "key": "autoremind3" }, { "key": "communication" }],
            icon: 'reports-latepayment.jpg',
            desc: '_latepayment_Report_',
            isVisible: true,
            isCommunication: true
        },];
    return {
        reportTypes: reportTypes
    };
})());
//# sourceMappingURL=reports.config.js.map